import { create } from 'zustand';
import { persist } from 'zustand/middleware';

interface SidebarNavState {
  /** Persisted open/closed state per collapsible nav group, keyed by NavGroup.id.
   *  Groups absent from the map fall back to their defaultOpen (or open). */
  openGroups: Record<string, boolean>;
  _hasHydrated: boolean;

  // Actions
  setGroupOpen: (id: string, open: boolean) => void;
  setHasHydrated: (state: boolean) => void;
}

export const useSidebarNavStore = create<SidebarNavState>()(
  persist(
    (set) => ({
      openGroups: {},
      _hasHydrated: false,

      setHasHydrated: (state: boolean) => {
        set({ _hasHydrated: state });
      },

      setGroupOpen: (id: string, open: boolean) =>
        set((state) => ({
          openGroups: { ...state.openGroups, [id]: open },
        })),
    }),
    {
      name: 'sidebar-nav-storage',
      partialize: (state) => ({ openGroups: state.openGroups }),
      onRehydrateStorage: () => (state) => {
        state?.setHasHydrated(true);
      },
    }
  )
);
